// extracted by mini-css-extract-plugin
export default {"SearchResults":"SearchResults_SearchResults__AztWW"};